import React from 'react';
import {
  Button,
  DevicesOtherIcon,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  LogoutIcon,
  Text,
} from '@billda/design-system';

interface LogoutOptionsDialogProps {
  open: boolean;
  onClose: () => void;
  onLogout: () => void;
  onLogoutAll: () => void;
}

export const LogoutOptionsDialog: React.FC<LogoutOptionsDialogProps> = ({
  open,
  onClose,
  onLogout,
  onLogoutAll,
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <DialogContent data-testid="logout-options-dialog">
        <DialogHeader>Sign Out</DialogHeader>
        <Text variant="body2" color="secondary" className="mb-4">
          Choose how you want to sign out:
        </Text>
        <div className="flex flex-col gap-4">
          <Button
            variant="outline"
            fullWidth
            className="justify-start py-3"
            onClick={onLogout}
            data-testid="logout-this-device-button"
          >
            <LogoutIcon aria-hidden="true" className="size-4" />
            Sign out of this browser
          </Button>
          <Button
            variant="outlineDanger"
            fullWidth
            className="justify-start py-3"
            onClick={onLogoutAll}
            data-testid="logout-all-devices-button"
          >
            <DevicesOtherIcon aria-hidden="true" className="size-4" />
            Sign out of all devices
          </Button>
        </div>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={onClose}
            data-testid="logout-cancel-button"
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
